<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :supervisores="enableSupervisor"
          :vendedores="enableVendedores"
          :receitas="enableReceita"
          :redes="enableRede"
          :categorias="enableCategoria"
          :promotores="enablePromotor"
          :classificacoes="enableClassificacao"
          :habilitar-filtros-data="enableFiltrosDados"
          :url="link"
        />
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="3"
          >
            <dashoard-card-view
              :exibir-texto-titulo="true"
              :code-information="'100'"
              :text="'Faturamento'"
              :texto-information="textoFaturamento"
              :style-object="styleObject"
              :componente-valor-faturamento="true"
              :valor="valorFaturamento"
              :valor2="valorFaturamentoMesAnterior"
              :valor3="valorFaturamentoMesAnoAnterior"
              :valor4="porcetangemFatxMesAnterior"
              :valor5="porcetangemFatxAnoAnterior"
              :exibir-valor-porcentagem="true"
              :padding="dynamicPaddingBloco1"
              :loading="loadingFaturamento"
            />
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="3"
          >
            <dashoard-card-view
              :exibir-texto-titulo="true"
              :code-information="'409'"
              :text="'Devolução Imprópria'"
              :texto-information="textoDevolucao"
              :style-object="styleObjectDevolucao"
              :componente-valor-faturamento="true"
              :valor="devolucao"
              :valor2="valorDevolucaoMesAnterior"
              :valor3="valorDevolucaoMesAnoAnterior"
              :valor4="porcetangemDevxMesAnterior"
              :valor5="porcetangemDevxAnoAnterior"
              :exibir-valor-porcentagem="true"
              :padding="dynamicPaddingBloco1"
              :loading="loadingDevolucao"
            />
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="3"
          >
            <dashoard-card-view
              :exibir-texto-titulo="true"
              :code-information="'410'"
              :text="'Brindes / Perda'"
              :texto-information="textoBrinde"
              :style-object="styleObjectBrinde"
              :componente-valor-faturamento="true"
              :valor="valorBrinde"
              :valor2="valorBrindeMesAnterior"
              :valor3="valorBrindeAnoAnterior"
              :valor4="porcetangemBrindexMesAnterior"
              :valor5="porcetangemBrindexAnoAnterior"
              :exibir-valor-porcentagem="true"
              :padding="dynamicPaddingBloco1"
              :loading="loadingBrinde"
            />
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="3"
          >
            <dashoard-card-view
              :exibir-texto-titulo="true"
              :code-information="'411'"
              :text="'Margem Contribuição (%)'"
              :texto-information="textoMargemContribuicao"
              :style-object="styleObject"
              :componente-valor-faturamento="true"
              :valor="valorMargem"
              :valor2="valorMargemMesAnterior"
              :valor3="valorMargemAnoAnterior"
              :padding="dynamicPaddingBloco1"
              :loading="loadingMargem"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="3"
            lg="3"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <dashoard-card-view
                  :exibir-texto-titulo="true"
                  :code-information="'102'"
                  :text="'Meta'"
                  :texto-information="textoMeta"
                  :style-object="styleObjectMeta"
                  :componente-valor-pie="true"
                  :grafico-id="'pieFatxMetaComercial6'"
                  :title="titleChartMeta"
                  :dados-grafico="chartMeta"
                  :titulo-id="'tituloFatxMetaComercial6'"
                  :valor="meta"
                  :exibir-titulo-grafico="true"
                  :padding="dynamicPaddingBloco1"
                  :loading="loadingMeta"
                  style="margin: 0rem 0 0 0"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <dashoard-card-view
                  :exibir-texto-titulo="true"
                  :code-information="'109'"
                  :text="'Qual a tendência de faturamento?'"
                  :texto-information="textoTendencia"
                  :style-object="styleObject"
                  :componente-valor="true"
                  :valor="valorTedenciaFaturamento"
                  :padding="dynamicPaddingBloco1"
                  :loading="loadingValorTendenciaFaturamento"
                  style="margin: 0rem 0 0 0"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <dashoard-card-view
                  :exibir-texto-titulo="true"
                  :code-information="'108'"
                  :text="'E quanto falta para atingirmos?'"
                  :texto-information="textoAtigimento"
                  :style-object="styleObject"
                  :componente-grafico="true"
                  :grafico-id="'myChart5'"
                  :grafico-id2="'myChart6'"
                  :dados-grafico="chartValorMonetario"
                  :lengenda-valor-moterio="true"
                  :valor-exibicao="valorExibicao"
                  :valor-restante="valorRestante"
                  :dados-grafico2="chartValorMonetarioDiario"
                  :enable-grafico-valor-monetario="true"
                  :padding="dynamicPaddingBloco1"
                  :loading="loadingGraficoValorMonetarioDiario"
                  style="margin: 0rem 0 0 0"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            id="componenteFaturamentoAtual"
            cols="12"
            sm="12"
            md="9"
            lg="9"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Comparativo Fat. x Meta
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip top>
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationFatxMetaComercial4"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('103')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="codigo === '103'"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <div
                      v-if="loadingFaturamentoxMeta"
                      id="carregaDados"
                      class="text-center"
                      :style="styleObject"
                    >
                      <v-icon
                        light
                        class="custom-loader"
                        :style="styleObject"
                      >
                        mdi-cached
                      </v-icon>
                      Carregando Dados...
                    </div>
                    <div
                      v-else-if="error"
                      class="alert alert-danger"
                    >
                      {{ error }}
                    </div>
                    <div>
                      <canvas
                        id="myChart"
                      />
                      <div
                        id="legendabarline"
                        class="text-center px-3"
                      >
                        <v-row
                          align="center"
                          class="ma-0"
                        >
                          <v-avatar
                            class="mr-1"
                            color="#ed934f"
                            size="12"
                          />
                          <span class="mr-3 font-weight-light">Meta Diária</span>
                          <v-avatar
                            class="mr-1"
                            color="#4780b8"
                            size="12"
                          />
                          <span class="mr-3 font-weight-light">Acima da Meta</span>
                          <v-avatar
                            class="mr-1"
                            color="#cadaed"
                            size="12"
                          />
                          <span class="mr-3 font-weight-light">Abaixo da Meta</span>
                        </v-row>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <v-divider
          id="dividerBloco1"
          class="mb-5"
        />
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="4"
          >
            <dashoard-card-view
              :exibir-texto-titulo="true"
              :code-information="'110'"
              :text="'Qual a quantidade de dias úteis no mês?'"
              :texto-information="textoDiasUteis"
              :style-object="styleObject"
              :componente-dias-uteis="true"
              :dias-uteis="diasUteis"
              :dias-pecorrido="diasPecorrido"
              :padding="dynamicPaddingBloco3"
              :loading="loadingDiasPercorrido"
            />
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="4"
          >
            <dashoard-card-view
              :exibir-texto-titulo="true"
              :code-information="'111'"
              :text="'E minha carteira de pedidos?'"
              :texto-information="textoPedidos"
              :style-object="styleObject"
              :componente-valor="true"
              :valor="valorPedidos"
              :padding="dynamicPaddingBloco3"
              :loading="loadingValorPedidos"
            />
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="4"
          >
            <dashoard-card-view
              :exibir-texto-titulo="true"
              :code-information="'112'"
              :text="'E quanto está minha volumetria?'"
              :texto-information="textoVolume"
              :style-object="styleObject"
              :componente-valor="true"
              :valor="`${valorVolume} Kg`"
              :padding="dynamicPaddingBloco3"
              :loading="loadingVolume"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import Comercial from '../../../../services/comercial'
  import Comercial6 from '../../../../services/comercial6'
  import Chart from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels'

  export default {
    name: 'PageComercial',
    emits: ['updateDatas', 'setDados', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashoardCardView: () => import('../../components/core/CardView'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      styleObjectError: {
        color: localStorage.corError,
      },
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectMeta: {
        color: '#ed934f',
      },
      styleObjectCarteiraPedidos: {
        color: '#9d9ac5',
      },
      styleObjectDevolucao: {
        color: '#C62828',
      },
      styleObjectBrinde: {
        color: '#4CAF50',
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      metaMensal: 0,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      select: [],
      empresa: [],
      supervisores: [],
      vendedores: [],
      receita: [],
      rede: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      codigo: 0,
      textoFaturamento: '',
      textoMeta: '',
      textoFaturamentoMeta: '',
      textoAtigimento: '',
      textoTendencia: '',
      textoDiasUteis: '',
      textoPedidos: '',
      textoVolume: '',
      textoDevolucao: '',
      textoBrinde: '',
      textoMargemContribuicao: '',
      orientacao: [],
      codigoIds: ['100', '101', '103', '108', '109', '110', '111', '112', '409', '410', '411'],
      permissaoGestaoComercial: '',
      activeHover: false,
      paginaEnable: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableSupervisor: true,
      enableVendedores: true,
      enableReceita: true,
      enableClassificacao: true,
      enableFiltrosDados: false,
      enableRede: true,
      enablePromotor: true,
      enableCategoria: true,
      devolucaoImpropria: 0,
      porcentagemImpropria: 0,
      devImpropriaEnable: false,
      link: window.location.href,
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFaturamentoMesAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFaturamentoMesAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      porcetangemFatxMesAnterior: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      porcetangemFatxAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      valorBrinde: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorBrindeMesAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorBrindeAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      porcetangemBrindexMesAnterior: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      porcetangemBrindexAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      valorMargem: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      valorMargemMesAnterior: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      valorMargemAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      devolucao: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucaoMesAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorDevolucaoMesAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      porcetangemDevxMesAnterior: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      porcetangemDevxAnoAnterior: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      meta: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      chartMeta: {},
      titleChartMeta: '',
      chartValorMonetario: {},
      chartValorMonetarioDiario: {},
      valorTedenciaFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      legendaGrafico: [
        { cor: '#ed934f', status: 'Meta Diária' },
        { cor: '#4780b8', status: 'Acima da Meta' },
        { cor: '#cadaed', status: 'Abaixo da Meta' },
      ],
      chartBarLinha: {},
      valorRestante: '',
      valorExibicao: '',
      valorRestante2: '',
      valorExibicao2: '',
      diasUteis: '0',
      diasPecorrido: '0',
      valorPedidos: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorVolume: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      dynamicPaddingBloco1: '',
      dynamicPaddingBloco2: '',
      dynamicPaddingBloco3: '',
      loadingFaturamento: false,
      loadingDevolucao: false,
      loadingBrinde: false,
      loadingMargem: false,
      loadingMeta: false,
      loadingGraficoMeta: false,
      loadingFaturamentoxMeta: false,
      loadingGraficoValorMonetarioDiario: false,
      loadingValorTendenciaFaturamento: false,
      loadingDiasPercorrido: false,
      loadingValorPedidos: false,
      loadingVolume: false,
      error: null,
      textoOrientacao: '',
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.primeiroDia)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Gestão Comercial')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingBloco1 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 77.6rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 18rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingBloco1 = 'padding-right: 4rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 54.5rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 10rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingBloco1 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 12rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 12rem !important'
        } else {
          this.dynamicPaddingBloco1 = 'padding-right: 1rem !important'

          this.dynamicPaddingBloco2 = 'padding-right: 47rem !important'

          this.dynamicPaddingBloco3 = 'padding-right: 5rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento, classificacao, produto, cidade, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisores = supervisores
        this.vendedores = vendedores
        this.receita = receita
        this.rede = redes
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', primeiroDia)
        localStorage.setItem('dataFinal', dataFinal)

        this.atualizaDados()
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      updateDate () {
        eventEmit.$emit('update-datas', this.primeiroDia, this.date, this.select, this.supervisores, this.receita, this.vendedores, this.rede, this.categoria, this.promotor)
      },

      async enableTexto (value) {
        await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value).then(resposta => {
          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao

            this.codigo = value
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.message === 'Permissão para a pagina não encontrada, metodo 8') {
            this.$router.push('/dashboard')
          }
        })
      },

      async atualizaDados () {
        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFaturamentoMesAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFaturamentoMesAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.porcetangemFatxMesAnterior = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.porcetangemFatxAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

        this.devolucao = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorDevolucaoMesAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorDevolucaoMesAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.porcetangemDevxMesAnterior = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.porcetangemDevxAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

        this.valorBrinde = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorBrindeMesAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorBrindeAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.porcetangemBrindexMesAnterior = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.porcetangemBrindexAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

        this.valorMargem = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.valorMargemMesAnterior = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.valorMargemAnoAnterior = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

        this.valorTedenciaFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.diasUteis = '0'
        this.diasPecorrido = '0'
        this.valorPedidos = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorVolume = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.titleChartMeta = ''
        this.valorRestante = ''
        this.valorExibicao = ''
        this.valorRestante2 = ''
        this.valorExibicao2 = ''

        if (this.chartMeta.data) {
          this.chartMeta.destroy()
        }

        if (this.chartBarLinha.data) {
          this.chartBarLinha.destroy()
        }

        if (this.chartValorMonetario.data) {
          this.chartValorMonetario.destroy()
        }

        if (this.chartValorMonetarioDiario.data) {
          this.chartValorMonetarioDiario.destroy()
        }

        this.loadingFaturamento = true
        this.loadingDevolucao = true
        this.loadingBrinde = true
        this.loadingMargem = true
        this.loadingMeta = true
        this.loadingFaturamentoxMeta = true
        this.loadingGraficoValorMonetarioDiario = true
        this.loadingValorTendenciaFaturamento = true
        this.loadingDiasPercorrido = true
        this.loadingValorPedidos = true
        this.loadingVolume = true

        await Comercial6.showDadosFaturamento(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, this.classificacao).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamento = resposta.data.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorFaturamentoMesAnterior = resposta.data.faturamentoMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorFaturamentoMesAnoAnterior = resposta.data.faturamentoAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.porcetangemFatxMesAnterior = resposta.data.porcetangemFatxMesAnterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            this.porcetangemFatxAnoAnterior = resposta.data.porcetangemFatxAnoAnterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

            eventEmit.$emit('disable-loading', false)
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamento = resposta.data.valorFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            eventEmit.$emit('disable-loading', false)
            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamento = false })

        await Comercial6.showDadosDevolucaoImpropria(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, this.classificacao).then(resposta => {
          if (resposta.data.status) {
            this.devolucao = resposta.data.devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorDevolucaoMesAnterior = resposta.data.devolucaoMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorDevolucaoMesAnoAnterior = resposta.data.devolucaoAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.porcetangemDevxMesAnterior = resposta.data.porcetangemDevxMesAnterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            this.porcetangemDevxAnoAnterior = resposta.data.porcetangemDevxAnoAnterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            eventEmit.$emit('disable-loading', false)

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDevolucao = false })

        await Comercial6.showDadosBrindes(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, this.classificacao).then(resposta => {
          if (resposta.data.status) {
            this.valorBrinde = resposta.data.brinde.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorBrindeMesAnterior = resposta.data.brindeMesAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorBrindeAnoAnterior = resposta.data.brindeAnoAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.porcetangemBrindexMesAnterior = resposta.data.porcetangemBrindexMesAnterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            this.porcetangemBrindexAnoAnterior = resposta.data.porcetangemBrindexAnoAnterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            eventEmit.$emit('disable-loading', false)

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingBrinde = false })

        await Comercial6.showDadosMargem(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, this.classificacao).then(resposta => {
          if (resposta.data.status) {
            this.valorMargem = resposta.data.margem.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
            this.valorMargemMesAnterior = resposta.data.margemMesAnterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
            this.valorMargemAnoAnterior = resposta.data.margemAnoAnterior.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            eventEmit.$emit('disable-loading', false)

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingMargem = false })

        await Comercial6.showDadosMeta(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, this.classificacao).then(resposta => {
          if (resposta.data.status) {
            this.meta = resposta.data.meta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.titleChartMeta = resposta.data.faturamentoMensal.toString().replace('.', ',') + '%'

            const ctx = document.getElementById('pieFatxMetaComercial6').getContext('2d')

            this.chartMeta = new Chart(ctx, {
              type: 'doughnut',
              data: {
                labels: ['Faturamento', 'Meta'],
                datasets: [
                  {
                    label: 'Faturamento',
                    data: [resposta.data.faturamentoMensal, resposta.data.valorMeta],
                    backgroundColor: [
                      '#4780b8',
                      '#cadaed',
                    ],
                  },
                ],
              },
              options: {
                legend: {
                  display: false,
                },
                responsive: true,
                circumference: 3.1,
                rotation: 3.15,
                cutoutPercentage: 70,
                tooltips: {
                  enabled: false,
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingMeta = false })

        await Comercial.showDadosGraficoBarrasFaturamentoxMeta(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, [], this.classificacao).then(resposta => {
          this.error = null

          if (resposta.data.status) {
            const ctx = document.getElementById('myChart').getContext('2d')

            this.chartBarLinha = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.diasFaturamento,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamentoMensal,
                    backgroundColor: resposta.data.colors,
                    order: 2,
                  },
                  {
                    label: 'Meta',
                    data: resposta.data.valorMeta,
                    type: 'line',
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 10,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return 'Faturamento - ' + tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 1) {
                        return 'Meta - ' + tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            if (this.chartBarLinha.data) {
              this.chartBarLinha.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            if (this.chartBarLinha.data) {
              this.chartBarLinha.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingFaturamentoxMeta = false })

        await Comercial.showDadosGraficoBarrasValorMonetario(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, [], this.classificacao).then(resposta => {
          if (resposta.data.status) {
            this.valorRestante = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const ctx = document.getElementById('myChart5').getContext('2d')

            this.chartValorMonetario = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: ['Mês Completo'],
                datasets: [
                  {
                    label: 'Fatura',
                    data: [resposta.data.valorFaturamento],
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                  {
                    label: 'Meta',
                    data: [resposta.data.valorMeta],
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: true,
                    color: function (context) {
                      if (context.dataset.label === 'Fatura') {
                        return '#ed934f'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      var type = data.datasets[tooltipItem.datasetIndex].label
                      var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                      return type + ': ' + valor
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        tooltipItem[0].xLabel = 'Faturamento até momento'

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 1) {
                        tooltipItem[0].xLabel = 'O que falta'

                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.valorRestante = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorExibicao = ''

            if (this.chartValorMonetario.data) {
              this.chartValorMonetario.destroy()
            }

            this.showSnackbar('error', 3000, 'Indicador "Quanto falta para atingirmos". Não há meta no mês corrente')
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorRestante = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorExibicao = ''

            if (this.chartValorMonetario.data) {
              this.chartValorMonetario.destroy()
            }

            this.showSnackbar('error', 3000, 'Indicador "Quanto falta para atingirmos". Não há faturamento no mês corrente')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })

        await Comercial.showDadosGraficoBarrasValorMonetarioMetaDiario(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, [], this.classificacao).then(resposta => {
          if (resposta.data.status) {
            this.valorRestante2 = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            const ctx = document.getElementById('myChart6').getContext('2d')

            this.chartValorMonetarioDiario = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: ['Mês até hoje'],
                datasets: [
                  {
                    label: 'Fatura',
                    data: [resposta.data.valorFaturamento],
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                  {
                    label: 'Meta',
                    data: [resposta.data.valorMeta],
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: true,
                    color: function (context) {
                      if (context.dataset.label === 'Fatura') {
                        return '#ed934f'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 10,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      var type = data.datasets[tooltipItem.datasetIndex].label
                      var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                      return type + ': ' + valor
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        tooltipItem[0].xLabel = 'Faturamento até momento'

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 1) {
                        tooltipItem[0].xLabel = 'O que falta'

                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            if (this.chartValorMonetarioDiario.data) {
              this.chartValorMonetarioDiario.destroy()
            }

            this.valorExibicao2 = false
            this.valorRestante2 = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            if (this.chartValorMonetarioDiario.data) {
              this.chartValorMonetarioDiario.destroy()
            }

            this.valorRestante2 = resposta.data.valorRestante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.valorExibicao2 = false
            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingGraficoValorMonetarioDiario = false })

        await Comercial.showTendenciaFaturamento(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, [], this.classificacao).then(resposta => {
          if (resposta.data.status) {
            this.valorTedenciaFaturamento = resposta.data.valorTendencia.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não hsá tendência pro mês selecionado') {
            this.valorTedenciaFaturamento = resposta.data.valorTendencia.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingValorTendenciaFaturamento = false })

        await Comercial.showDiasFaturamento(this.primeiroDia, this.date, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.diasUteis = resposta.data.diaUtil.toString()
            this.diasPecorrido = resposta.data.diatrabalhados.toString()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.methods
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDiasPercorrido = false })

        await Comercial.showValorMonetarioPedidosAbertos(this.primeiroDia, this.date, this.select, this.receita, localStorage.tokencontrato, this.supervisores, this.vendedores, this.rede, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.valorPedidos = resposta.data.pedidosAberto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingValorPedidos = false })

        await Comercial.showValorTotalVolume(this.primeiroDia, this.date, this.select, this.supervisores, this.receita, localStorage.tokencontrato, this.vendedores, this.rede, this.categoria, this.promotor, [], this.classificacao).then(resposta => {
          if (resposta.data.status) {
            this.valorVolume = resposta.data.kilosFaturado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingVolume = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #componenteFaturamentoAtual {
      margin: 2rem 0 0 0 !important;
    }

    #componenteAnteriores {
      margin: 2rem 0 0 0
    }
  }
</style>

<style lang="sass">
  #iconInformationFaturamento
    margin: -1.5rem 0 0 0

  #componenteAnteriores
    margin: -0.1rem 0 0 0

  #componenteFatMesAnotAnterior
    margin: 0.8rem 0 0 0

  #componenteFaturamentoAtual
    margin: -2rem 0 0 0

  #componenteMetaAtual
    margin: 0.1rem 0 0 0

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listBarchart
    margin: -2rem 0 0 -1rem

</style>
